import type { Ref } from 'vue';
import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { Channel } from '@getaccept/pusher';

export const useChannelsStore = defineStore('channels', () => {
  const userChannel: Ref<Channel> = ref(null);

  const setUserChannel = (channel: Channel) => {
    userChannel.value = channel;
  };

  return { setUserChannel, userChannel };
});
